import React, { useState, useEffect } from 'react';
import { getMonitorsBySymbol } from '../../../services/MonitorsService';
import { processError } from '../../../services/ServiceUtils';

/**
 * props:
 * - symbol
 * - monitorId
 * - onChange
 */
function SelectMonitor(props) {

    const [monitors, setMonitors] = useState([]);

    useEffect(() => {
        if (!props.symbol) return setMonitors([]);

        getMonitorsBySymbol(props.symbol)
            .then(result => setMonitors(result))
            .catch(err => setMonitors([processError(err)]));
    }, [props.symbol]);

    function onMonitorChange(event) {
        if (props.onChange)
            props.onChange(event);
    }

    return (
        <select className='form-select' id='monitorId' value={props.monitorId} onChange={onMonitorChange}>
            <option value='0'>Selecionar monitor...</option>
            {
                monitors
                    ? monitors.map(m => (<option key={m.id} value={m.id}>{m.type} {m.interval}</option>))
                    : <option>Nenhum monitor encontrado</option>
            }
        </select>
    )
}

export default SelectMonitor;